import React from 'react';
import { Tooltip } from '@mui/material';
import { useProfileRole } from '../../hooks/useProfileRole';

interface ProtectedActionProps {
    children: React.ReactElement;
    showTooltip?: boolean;
    tooltipText?: string;
}

export const ProtectedAction: React.FC<ProtectedActionProps> = ({
    children,
    showTooltip = true,
    tooltipText = "You don't have permission to edit"
}) => {
    const {canEdit} = useProfileRole();

    // Handler to prevent navigation when user can't edit
    const handleClick = (e: React.MouseEvent) => {
      if (!canEdit) {
        e.preventDefault();
        e.stopPropagation();
      } else if (children.props.onClick) {
        // Call original onClick if exists
        children.props.onClick(e);
      }
    };

    const wrappedChild = React.cloneElement(children, {
      disabled: !canEdit,
      onClick: handleClick,
      style: {
        ...children.props.style,
        opacity: canEdit ? 1 : 0.5,
        cursor: canEdit ? 'pointer' : 'not-allowed'
      }
    });

    if (!canEdit && showTooltip) {
      // minimal wrapper: only for tooltip anchor, no class/style copy
      return (
        <Tooltip title={tooltipText}>
          <span
            style={{display: 'inline-flex', pointerEvents: 'auto'}}
            aria-disabled="true"
          >
            {wrappedChild}
          </span>
        </Tooltip>
      );
    }
    // if (!canEdit && showTooltip) {
    //     const childProps: any = children.props || {};
    //     const childStyle: React.CSSProperties = childProps.style || {};
    //     // choose a display that matches the child or fallback
    //     const inferredDisplay =
    //         childStyle.display ||
    //         (childProps.fullWidth ? 'block' : 'inline-block');
    //
    //     const wrapperStyle: React.CSSProperties = {
    //         display: inferredDisplay,
    //         width: childStyle.width ?? undefined,
    //         height: childStyle.height ?? undefined,
    //         // ensure the wrapper can receive hover events for the tooltip
    //         pointerEvents: 'auto'
    //     };
    //
    //     return (
    //         <Tooltip title={tooltipText}>
    //     <span
    //         style={wrapperStyle}
    //         className={childProps.className}
    //         aria-disabled
    //     >
    //       {wrappedChild}
    //     </span>
    //         </Tooltip>
    //     );
    // }

    return wrappedChild;
};
